import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { ACard, AH1, ABtn, Status, fmtDate } from "./ui";

export default function AdminEnrollments() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/enrollments").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const toggle = async (e) => {
    const url = e.status === "active" ? "/admin/enrollments/revoke" : "/admin/enrollments";
    await api.post(url, { user_id: e.user_id, course_id: e.course_id });
    toast.success(e.status === "active" ? "تم سحب الوصول" : "تم منح الوصول");
    load();
  };
  return (
    <div data-testid="admin-enrollments">
      <AH1>الاشتراكات ومتابعة التقدم</AH1>
      <div className="space-y-2">
        {list.length === 0 && <p className="text-slate-500">لا توجد اشتراكات.</p>}
        {list.map((e) => (
          <ACard key={`${e.user_id}-${e.course_id}`} className="grid md:grid-cols-12 gap-3 items-center !py-4" data-testid={`enrollment-row-${e.user_id}-${e.course_id}`}>
            <div className="md:col-span-3 min-w-0"><p className="text-sm font-medium truncate">{e.user?.name}</p><p className="text-xs text-slate-500 truncate" dir="ltr">{e.user?.email}</p></div>
            <p className="md:col-span-3 text-sm truncate">{e.course_title}</p>
            <div className="md:col-span-3 flex items-center gap-2"><Progress value={e.percent} className="h-1.5 bg-white/10" /><span className="text-xs text-slate-400">{e.percent}%</span></div>
            <p className="md:col-span-1 text-[11px] text-slate-500">{fmtDate(e.last_activity)}</p>
            <div className="md:col-span-2 flex items-center gap-2 md:justify-end">
              <Status s={e.status} />
              <ABtn variant={e.status === "active" ? "danger" : "success"} onClick={() => toggle(e)}>{e.status === "active" ? "سحب" : "تفعيل"}</ABtn>
            </div>
          </ACard>
        ))}
      </div>
    </div>
  );
}
